/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetEmployerSelectWithTasksQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEmployerSelectWithTasksQuery = { __typename: 'Query', employers: Array<{ __typename: 'Employer', id: string, tasks: { __typename: 'TaskCollection', count: number } }> };


export const GetEmployerSelectWithTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmployerSelectWithTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetEmployerSelectWithTasksQuery, GetEmployerSelectWithTasksQueryVariables>;